import { useEffect, useState } from "react";
import { getThingsToDoURL } from "./gatsby-helpers";
import { RCL as useTranslation } from "../components/RCL";
import { usePageContext } from "../context/PageContext";
import { hotelInfoServiceClient } from "../services/client";

const useNexusFetchHook = ({ destinationCode, isDetailsModal, excursionData, isExcursion }) => {
	const code = destinationCode;
	const [val, setVal] = useState([]);
	const { lang, slug } = usePageContext();
	const exploreMoreLabel = useTranslation({
		searchKey: "explore-more",
	});
	const modalMessage = useTranslation({
		searchKey: "nexus-external-popup-message-vwq",
	});

	let URL = `/wvi/${lang}/excursionsDestinationCode?dest=${code}`;

	if (isExcursion) {
		URL = `/wvi/${lang}/excursion/${code}`;
	}

	useEffect(() => {
		if (!excursionData?.length) {
			hotelInfoServiceClient
				.fetch(URL)
				.then(res => res.json())
				.then(response => {
					const collections = response[0]?.ExcursionsCollection?.Items.map(res => {
						const excursionPageUrl = res?.NexusExcursionPageUrlCollection?.Items.map(item => ({
							excursionUrl: item?.ExcursionUrl,
							excursionPageName: item?.ExcursionPageName,
							destinationCode: res?.DestinationCode,
						}));
						return {
							destinationCode: res?.DestinationCode,
							destinationName: res?.DestinationName,
							excursionImages: res?.ExcursionImages[0],
							highlights: res?.Highlights,
							juniperProductCode: res?.JuniperProductCode,
							nexusExcursionPageUrl: excursionPageUrl,
							productName: res?.ProductName,
							videoUrl: res?.VideoUrl,
						};
					});
					setVal(collections);
				})
				.catch(error => {
					console.error("Nexus fetch failure: ", error);
					return null;
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [code, lang]);

	return val?.reduce(
		(accumulator, excursion, index) => {
			const cardData = {
				modalMessage,
				id: excursion.juniperProductCode || index,
				title: excursion?.productName,
				link: {
					variant: "Primary",
					text: exploreMoreLabel,
					to: isDetailsModal
						? excursion?.nexusExcursionPageUrl?.find(e => e?.destinationCode?.includes(code))
								?.excursionUrl
						: getThingsToDoURL(lang, excursion?.slug ?? slug, excursion?.productName),
				},
				image: null,
			};

			cardData.image = [
				{
					width: 1024,
					height: 576,
					baseUrl: excursion?.excursionImages
						? "res.cloudinary.com/nexustoursvacations"
						: "assets.vacationvaults.ca",
					public_id:
						excursion?.excursionImages?.replace(
							"//res.cloudinary.com/nexustoursvacations/f_auto,q_auto",
							""
						) ?? "sunwing-prod/web-content/placeholder.jpg", // Fallback img
					secure_url:
						excursion?.excursionImages ??
						"https://assets.vacationvaults.ca/image/upload/sunwing-prod/web-content/placeholder.jpg", // Fallback img
				},
			];
			return {
				excursionCardData: [...accumulator.excursionCardData, cardData],
			};
		},
		{
			excursionCardData: [],
		}
	);
};

export { useNexusFetchHook };
